import React from "react";
import FormFooter, { IFormFooterProps } from "./FormFooter";
import { closeIcon } from "../../assets/icons/SvgIconList";
import { cn } from "../../lib";

interface IFormRightModalWrapper {
  onClose: () => void;
  title: string;
  mutedTitle?: string;
  subTitle?: string;
  children: React.ReactNode;
  containerClassName?: string;
  footer?: IFormFooterProps;
}

const FormRightModalWrapper = (props: IFormRightModalWrapper) => {
  return (
    <div className="absolute top-0 right-0 transition-all w-full overflow-hidden">
      <div className="relative flex justify-end">
        <div
          className="absolute bg-invert z-20 opacity-30 top-0 right-0 h-full w-full"
          onClick={() => props.onClose()}
        />
        <div
          className={cn(`z-50 h-svh`, {
            [`${props.containerClassName}`]: props.containerClassName,
          })}
        >
          <div className="flex h-full justify-end w-full">
            <div className="h-full bg-subtle w-full flex flex-col form-modal-wrapper-transform p-4">
              <div className="flex justify-between">
                <div className="flex items-center">
                  <h5 className="uppercase font-semibold text-lg">
                    {props.title}
                  </h5>
                  {props.mutedTitle && (
                    <h5 className="font-medium text-muted text-sm ml-2">
                      ({props.mutedTitle})
                    </h5>
                  )}
                </div>
                <div
                  onClick={() => props.onClose()}
                  className="grid place-items-center rounded-lg w-8 h-8 cursor-pointer"
                >
                  {closeIcon}
                </div>
              </div>
              <div className="flex-1 flex flex-col overflow-y-scroll pt-4">
                {props.children}
              </div>
              {props.footer && <FormFooter {...props.footer} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormRightModalWrapper;
